import type { TFunction } from 'i18next';
import type { JSX } from 'react';
import React from 'react';

import type { SegmentExport } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import ExportRowActions from './ExportRowActions';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

interface IRow {
  original: SegmentExport;
}

const optionsColumn = (t: TFunction): IColumn<SegmentExport> => ({
  id: 'options',
  checkboxLabel: t('Options'),
  Header: TableColumnHeader({ title: t('Options') }),
  width: 80,
  sortable: false,
  className: tableStyles.cellCenter,
  Cell({ original }: IRow): JSX.Element {
    return <ExportRowActions record={original} />;
  },
});

export default optionsColumn;
